import React, { useState, useEffect, ChangeEvent } from 'react';
import { Autocomplete } from '@mui/material';
import StyledTextField from '../../components/styled-components/StyledTextField';
import AlertService from '../../services/notification.service';
import { NON_DiGIT_PATTERN } from '../../constants/patterns-constants';

const currentYear = new Date().getFullYear();

const generateYears = () => {
  const years: string[] = [];
  for (let year = 1900; year <= currentYear; year++) {
    years.push(year.toString());
  }
  return years.reverse();
};

const BirthYearField = ({
                          onChange,
                          value,
                          nameBlock,
                          name,
                          setErrorFields,
                          errorFields,
                          inputValue,
                          setInputValue
                        }) => {
  const years: string[] = generateYears();
  const [open, setOpen] = useState(false);
  const [wasInvalid, setWasInvalid] = useState(false);
  const element = document.getElementById('box-tabPanel');
  const elementModal = document.getElementById('container-entityObjectEditModal');
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    if (isFocused && open) {
      if (element !== null) {
        // @ts-ignore
        element.setAttribute('style', 'overflow-y: hidden');
      }
      if (elementModal !== null) {
        // @ts-ignore
        elementModal.setAttribute('style', 'overflow-y: hidden');
      }
    } else {
      if (element !== null) {
        // @ts-ignore
        element.setAttribute('style', 'overflow-y: auto');
      }
      if (elementModal !== null) {
        // @ts-ignore
        elementModal.setAttribute('style', 'overflow-y: auto');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFocused, open]);

  const validateYear = (val: string): boolean => {
    const year = parseInt(val, 10);

    if (val === '') {
      setErrorFields((prev) => ({ ...prev, [name]: false }));
      // setError(false);
      setWasInvalid(false);
      return true;
    }

    if (isNaN(year) || year < 1900 || year > currentYear) {
      setErrorFields((prev) => ({ ...prev, [name]: true }));
      // setError(true);
      if (!wasInvalid) {
        AlertService.warning(`The year must be between 1900 and ${currentYear}`);
        setWasInvalid(true);
      }
      return false;
    }
    setErrorFields((prev) => ({ ...prev, [name]: false }));
    // setError(false);
    setWasInvalid(false);
    return true;
  };

  const handleInputChange = (_e: any, newInputValue: string) => {
    const digitsOnly = newInputValue.replace(NON_DiGIT_PATTERN, '');
    setInputValue(digitsOnly);
    // validateYear(digitsOnly);
    if (validateYear(digitsOnly)) {
      onChange(nameBlock, name, digitsOnly);
      setErrorFields((prev) => ({ ...prev, [name]: false }));
    } else {
      setErrorFields((prev) => ({ ...prev, [name]: true }));
    }

  };

  const handleChange = (_e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, newValue: string | null) => {
    const val = newValue ?? '';
    if (validateYear(val)) {
      setInputValue(val);
      onChange(nameBlock, name, val || null);
      setErrorFields((prev) => ({ ...prev, [name]: false }));
    } else {
      setInputValue('');
      onChange(nameBlock, name, null);
    }
  };
  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  return (
    <Autocomplete
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      options={years}
      value={value}
      inputValue={inputValue}
      onInputChange={handleInputChange}
      onChange={handleChange}
      openOnFocus={isFocused}
      onFocus={handleFocus}
      onBlur={handleBlur}
      freeSolo
      renderInput={(params) => (
        <StyledTextField
          {...params}
          autoComplete="new-password"
          fullWidth
          name={name}
          label="Y.o.B"
          margin="dense"
          error={errorFields.birth_year}
          slotProps={{
            htmlInput: {
              ...params.inputProps,
              autoComplete: 'new-password',
              inputMode: 'numeric',
              pattern: '[0-9]*',
              maxLength: 4
            }
          }}
          onChange={(e) => {
            const val = e.target.value;
            if (/^\d{0,4}$/.test(val)) onChange(e);
          }}
        />
      )}
    />
  );
};

export default BirthYearField;